import { cn } from '@/utils/styles';

import { icons } from './constants';
import { Info } from 'lucide-react';
import { IconProps as IconCommonProps, IconName } from './types';

export type IconProps = IconCommonProps & {
  readonly name: IconName;
};

export function Icon({ name, className }: IconProps) {
  const Component = icons[name];

  if (!Component) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Icon "${name}" not found. Using fallback icon.`);
    }
    return <Info className={cn('text-warning-500', className)} />;
  }

  return <Component className={cn(`nteaser-icon-${name}`, className)} />;
}
